import './AccountLabel.scss';

import React from 'react';
import { connect } from 'react-redux';

import SweepModal from 'components/shared/Sweep/SweepModal';
import { getAccountsById } from 'state/account/AccountSelectors';
import { formatAccountNumber } from 'services/Formats';
import ShareClassConversionModal from 'components/shared/ShareClassConversion/ShareClassConversionModal';
import { shareClassConversionEnabled } from 'services/FeatureFlags';

const AccountLabel = ({ accounts, accountId, showAccountLabel = true }) => {
  const account = accounts[accountId];
  if (!account || !showAccountLabel) {
    return null;
  }

  const { isViewOnly, shareClassConversion, sweepAccount, sweepAccountId } = account;
  const showShareClassConversion =
    shareClassConversionEnabled() && shareClassConversion && shareClassConversion.activeShareClassConverted;
  const accountNumberWChecksum = formatAccountNumber(account);

  return (
    <div className="account-label-container">
      {showShareClassConversion && (
        <div className="account-label-with-icon">
          <div className="account-label b-margin-inline-end--micro--mini" aria-label="Share Class Conversion" id={`share-class-conversion-${accountId}`}>
            Share Class Conversion
          </div>
          <ShareClassConversionModal />
        </div>
      )}
      {isViewOnly && (
        <div className="account-label" aria-label="View Only" id={`view-only-${accountId}`}>
          View Only
        </div>
      )}
      {sweepAccount && (
        <div className="account-label-with-icon">
          <div id={`sweep-modal-dashboard-id-tiles-${sweepAccountId}`}
            className="account-label"
            aria-label="Sweep">
          Sweep{' '}
          </div>
          <SweepModal
            accountWChecksum={accountNumberWChecksum}
            linkId={`sweep-modal-link-${accountId}`}
            label="sweep-modal-dashboard"
            accountId={accountId}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  accounts: getAccountsById(state)
});

export default connect(mapStateToProps)(AccountLabel);
